import { FunctionComponent } from 'react'
import styled from 'styled-components'
import { useIntl } from '@/i18n/hooks/use-intl'

interface AboutProps {
  className?: string
  aboutList: string[]
  lastUpdatedAt: string | null
}

const About: FunctionComponent<AboutProps> = ({
  className,
  aboutList,
  lastUpdatedAt,
}) => {
  const { formatDate } = useIntl()

  return (
    <Wrapper className={className}>
      <Title>關於榜單</Title>
      <List>
        {lastUpdatedAt !== null && (
          <Item>{`最後更新時間：${formatDate(lastUpdatedAt, 'localeYearMonth')}`}</Item>
        )}
        {aboutList.map((about) => (
          <Item key={about}>{about}</Item>
        ))}
      </List>
    </Wrapper>
  )
}

const Title = styled.div`
  font-size: 20px;
  font-weight: 700;
`

const Item = styled.li``

const List = styled.ul`
  font-size: 16px;
  margin-bottom: 0;
  padding-left: 1em;

  ${Item} {
    list-style-type: disc;
  }
`

const Wrapper = styled.div`
  padding: 24px;
  background-color: ${({ theme }): string => theme.colors.background.white};
  border-left: 4px solid ${({ theme }): string => theme.colors.brand.primary};
  line-height: 1.4;
  color: ${({ theme }): string => theme.colors.text.primary};
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);

  ${Title} {
    margin-bottom: 16px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`

export default styled(About)``
